import { useMemo } from "react";
import styled from "styled-components";
import { API_CALLS } from "../../../../../API/api_calls";
import { API_PATHS } from "../../../../../API/api_paths";
import { ArticleProps } from "../../../../../redux/slices/article/Article";
import { FlexColumn, FlexRow } from "../../../../Common/Styles";
import { useFindContent } from "../../useFindContent";
import PreviewLayout from "../PreviewLayout";
import { PreviewContent } from "../style";
import ImageProps from "./Image";

const ImagePreview = ({ id, setIsPreviewOpen }: ImageProps.ImagePreview) => {
  const { content_data } = useFindContent(id) as ArticleProps.WithImageContent;

  const formatedImagList = useMemo(() => {
    const chunkCount = content_data.length > 5 ? 5 : content_data.length;
    return Array.from({ length: chunkCount }, (_, i) =>
      content_data.filter((_, index) => index % chunkCount === i)
    );
  }, [content_data]);

  return (
    <PreviewLayout
      onDelete={() => API_CALLS.ARTICLE.deleteASingleArticleContent(id)}
      onEdit={() => setIsPreviewOpen(false)}
      width="100%"
    >
      <PreviewContent>
        <FlexRow $gapInPx={8}>
          {formatedImagList.map((list, index) => (
            <Wrapper key={index} $gapInPx={8}>
              {list.map((image, i) => (
                <Image src={API_PATHS.posts.getPostImage + image.id} key={i} />
              ))}
            </Wrapper>
          ))}
        </FlexRow>
      </PreviewContent>
    </PreviewLayout>
  );
};

export default ImagePreview;

const Image = styled.img`
  display: block;
  width: 100%;
  border-radius: ${({ theme }) => theme.radius["radius-xxs"].value}rem;
  background-color: ${({ theme }) =>
    theme.Color.border["ui-border-neutral"].value};
`;

const Wrapper = styled(FlexColumn)`
  flex: 1;
`;
